module.exports = __webpack_public_path__ + "img/2.65ad051e.png";